import { Select } from 'antd';
import React from 'react';
import { CallCenterCos } from '../constants';

function SelectCallCenterCo({ value, onChange, ...other }) {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select an algorithm"
      allowClear
      {...other}
    >
      {Object.values(CallCenterCos).map((field) => (
        <Select.Option key={field.key} value={field.key}>
          {field.label}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectCallCenterCo;
